'use client';

import React from 'react';
import * as RadixSwitch from '@radix-ui/react-switch';
import styled from 'styled-components';
import { focusRing } from '@liftango/ui-tokens';

export interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  disabled?: boolean;
}

const Wrapper = styled.label`
  display: inline-flex;
  align-items: center;
  gap: ${(p) => p.theme.spaceAlias.sm};
  font-family: ${(p) => p.theme.fontFamily.ui};
  font-size: ${(p) => p.theme.fontSize.body};
  color: ${(p) => p.theme.colors.neutral.ink};
  cursor: pointer;
`;

const Track = styled(RadixSwitch.Root)`
  width: 36px;
  height: 20px;
  border-radius: 10px;
  background: ${(p) => p.theme.colors.neutral.line};
  border: none;
  padding: 0;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  &[data-state='checked'] {
    background: ${(p) => p.theme.colors.brand.primary};
  }
  ${focusRing}
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

const Thumb = styled(RadixSwitch.Thumb)`
  display: block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  transition: transform ${(p) => p.theme.transition.layout};
  transform: translateX(2px);
  &[data-state='checked'] {
    transform: translateX(18px);
  }
`;

export function Toggle({ checked, onChange, label, disabled }: ToggleProps) {
  return (
    <Wrapper>
      <Track checked={checked} onCheckedChange={onChange} disabled={disabled} aria-label={label}>
        <Thumb />
      </Track>
      {label}
    </Wrapper>
  );
}
